import { MAX_NGINX_URL_LENGTH, ORIGINAL_HOST_HEADER, ORIGINAL_PROTOCOL_HEADER, ORIGINAL_URL_HEADER, } from './constants';
import { composeHeaders } from './headers';
import { changeHost, extractHost, extractProtocol, isAbsoluteUrl, toSearchQueryParams, } from './utils';
export const buildOptions = ({ requestOptions, urlObject, headers, globalConfig = {
    httpMockServer: {
        enabled: false,
    },
}, }) => {
    const { url, method, params, fallback } = requestOptions;
    if (params) {
        if (typeof params !== 'object') {
            throw new Error('Search params must be an object');
        }
        if (fallback === null || fallback === void 0 ? void 0 : fallback.length) {
            if (method === 'GET' && !isValidGetRequest(requestOptions)) {
                const fallbackOptions = getFallbackRequestOptions(fallback);
                if (fallbackOptions) {
                    requestOptions = Object.assign(Object.assign({}, requestOptions), fallbackOptions);
                    if (fallbackOptions.method === 'POST') {
                        requestOptions.params = undefined;
                    }
                }
            }
        }
    }
    const localConfigOptions = maybeRedirectToMockServer(url, globalConfig);
    const newOptions = Object.assign(Object.assign(Object.assign({}, requestOptions), localConfigOptions), { headers });
    return newOptions;
};
export const buildAllHeaders = (requestOptions, wixHeadersOpts, globalConfig = {
    httpMockServer: {
        enabled: false,
    },
}, urlObject) => {
    const { url, disableWixHeaders, headers, includeWixHeaders } = requestOptions;
    const composedHeaders = composeHeaders({
        url,
        disableWixHeaders,
        includeWixHeaders,
        wixHeadersOpts,
    });
    const originalUrlHeader = getUrlHeaders(globalConfig, requestOptions, urlObject);
    return Object.assign(Object.assign(Object.assign({}, composedHeaders), lowerAllJsonKeys(headers)), originalUrlHeader);
};
export const getUrlHeaders = (globalConfig, requestOptions, urlObject) => {
    const { url, params } = requestOptions;
    const { host, protocol } = urlObject;
    const originalUrlHeader = globalConfig.httpMockServer.enabled
        ? {
            [ORIGINAL_URL_HEADER]: buildUrlFromRequest(url, params),
            [ORIGINAL_HOST_HEADER]: isAbsoluteUrl(url) ? extractHost(url) : host,
            [ORIGINAL_PROTOCOL_HEADER]: isAbsoluteUrl(url)
                ? extractProtocol(url)
                : protocol,
        }
        : {};
    return originalUrlHeader;
};
function maybeRedirectToMockServer(url, globalConfig) {
    if (globalConfig.httpMockServer.enabled) {
        const mockUrl = new URL(globalConfig.httpMockServer.mockServerUrl);
        return {
            url: changeHost(url, mockUrl.host),
        };
    }
    return {};
}
function buildUrlFromRequest(url, requestParams) {
    const { pathname, searchParams } = new URL(url, 'http://unused.com');
    requestParams = requestParams || searchParams;
    if (requestParams) {
        const params = toSearchQueryParams(requestParams) || requestParams.toString();
        const paramsAsString = params ? `?${params}` : '';
        return `${pathname}${paramsAsString}`;
    }
    return pathname;
}
function lowerAllJsonKeys(objectToChange) {
    objectToChange = objectToChange || {};
    const result = Object.keys(objectToChange).reduce((prev, key) => (Object.assign(Object.assign({}, prev), { [key.toLowerCase()]: objectToChange[key] })), {});
    return result;
}
function isValidGetRequest(requestOptions) {
    if (requestOptions.method !== 'GET') {
        return false;
    }
    const { url, params } = requestOptions;
    return `${url}${params}`.length < MAX_NGINX_URL_LENGTH;
}
function getFallbackRequestOptions(fallbackRequests) {
    for (const requestOption of fallbackRequests) {
        if (requestOption.method !== 'GET' || isValidGetRequest(requestOption)) {
            return requestOption;
        }
    }
}
//# sourceMappingURL=options.js.map